import $ from 'jquery';

$(document).ready(function() {

  $('#errormsg, .form-control-feedback').hide();

  $('#form_contact').submit(function() {
    var errormsg = $('#errormsg');
    errormsg.hide();
    $.post({
      url: '/contacto/send',
      data: $(this).serialize(),
      dataType: 'json'
    }).done(function(response) {
      if (response.success === true) {
        window.location.href = '/contacto/sent';
      }
      else {
        errormsg.show();
        switch (response.reason) {
          case 'missing':
            errormsg.text('Es necesario llenar todos los campos.');
            response.missing.forEach(function(item) {
              $('#'+item).parent().addClass('has-error has-feedback');
              $('#'+item).siblings('.form-control-feedback').show();
            });
            break;
          case 'captcha':
            errormsg.text('Código de verificación inválido.');
            break;
        }
      }
    }).fail(function() {
      errormsg.show();
      errormsg.text('Error al enviar los datos. Intente de nuevo.');
    });
    return false;
  });

  $('#form_contact .form-control[name]').on('input', function(event) {
    var input = $(this);
    var fg = input.parent();
    if (input.val() === '') {
      fg.addClass('has-error has-feedback');
      fg.find('.form-control-feedback').show();
    }
    else {
      fg.removeClass('has-error has-feedback');
      fg.find('.form-control-feedback').hide();
    }
  });

});
